"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.combineReducers = combineReducers;
function combineReducers() {
	var reducers = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	var reducerKeys = Object.keys(reducers);
	return function combination() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		var action = arguments[1];

		var hasChanged = false;
		var nextState = {};
		for (var i = 0; i < reducerKeys.length; i++) {
			var key = reducerKeys[i];
			nextState[key] = reducers[key](state[key], action);
			hasChanged = hasChanged || nextState[key] !== state[key];
		}
		return hasChanged ? nextState : state;
	};
}